import { Injector, Type } from '@angular/core';

export class AppInjectorService {
	private _injector: Injector;

	public setInjector(injector: Injector) {
		this._injector = injector;
	}

	public get<T>(service: Type<T>): T {
		return this._injector.get(service);
	}
}

export const AppInjector: AppInjectorService = new AppInjectorService();
